export default __webpack_public_path__ + "partner_11573a29.png";